import { RouterProvider } from 'react-router';

import { useErrorBoundary } from '@/infrastructure/errorHandler';
import { AppErrorFallback } from '@/pages/AppErrorFallback';
import { router } from '@/pages/router';

import { Toaster } from './components/ui/sonner';
import { HeadProvider } from './modules/common/application/Provider/Head';

const App = () => {
  const { ErrorBoundary } = useErrorBoundary();

  return (
    <ErrorBoundary fallback={<AppErrorFallback />}>
      <HeadProvider>
        <RouterProvider router={router} />
        <Toaster />
      </HeadProvider>
    </ErrorBoundary>
  );
};

export default App;
